import { render } from "./AddLink.vue?vue&type=template&id=bbc069f6&scoped=true"
import script from "./AddLink.vue?vue&type=script&lang=js"
export * from "./AddLink.vue?vue&type=script&lang=js"

import "./AddLink.vue?vue&type=style&index=0&id=bbc069f6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbc069f6"]])

export default __exports__